import { MostIntimateMomentCompatibilityOptionsType } from './types';

export const MOST_INTIMATE_MOMENT_COMPATIBILITY_OPTIONS: MostIntimateMomentCompatibilityOptionsType =
  [
    { id: 'breath_on_ear', title: '🫦 Her breath on your ear' },
    { id: 'pinned_against_wall', title: '❤️‍🔥Pinned against the wall' },
    { id: 'before_lose_control', title: '💣 Right before you lose control' },
    { id: 'eyes_saying_take_me', title: '👁️ Her eyes saying "take me"' },
  ];
